import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box
} from "@mui/material";
import { NavLink } from "react-router-dom";
import {
  UsersIcon,
  PointOfSaleIcon,
  ActivitiesIcon,
  OperationsIcon,
} from "./icons";
import { useAppSelector } from "redux/store";
import { IUserLoggedState } from "redux/features/loggedUserSlice";
import { UserRoles } from "Enums/UserRoles";
import { useIntl } from "react-intl";


const Sidebar = () => {
  const { user } = useAppSelector(
    (state: { userLoggedState: IUserLoggedState }) => state.userLoggedState
  );
  const { formatMessage } = useIntl();

  const allowedRoles = [UserRoles.ADMIN, UserRoles.SUPERADMIN,UserRoles.MANAGER];


  const dataForSidebarList = [
    
    
    {
      title: formatMessage({ id: "sidebar.operations" }),
      icon: <OperationsIcon />,
      url: "/operations",
      showToRoles: allowedRoles,
    },
    {
      title: formatMessage({ id: "sidebar.companies" }),
      icon: <ActivitiesIcon />,
      url: "/companies",
      showToRoles: [UserRoles.SUPERADMIN],
    },
    {
      title: formatMessage({ id: "sidebar.pointOfSale" }),
      icon: <PointOfSaleIcon />,
      url: "/point-of-sale",
      showToRoles: allowedRoles,
    }, 

    {
      title: formatMessage({ id: "sidebar.users" }),
      icon: <UsersIcon />,
      url: "/users",
      showToRoles: allowedRoles,
    },
  ];

  return (
    <Box sx={{minHeight: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
      <List
        sx={{
          margin: "1.5rem 1.75rem",
        }}
      >
        {dataForSidebarList.map((data) => {
          return (
            user?.role !== undefined &&
            data.showToRoles.includes(user?.role) && (
              <ListItem
                key={data.title}
                disablePadding
                sx={{
                  margin: "0.5rem 0",
                  borderRadius: "0.75rem",
                 
                  ".MuiListItemButton-root": {
                    height: "3.5rem",
                    padding: "0 1rem",
                    backgroundColor: "transparent",
                    ":hover": {
                      backgroundColor: "transparent",
                    }
                  },
                  ".MuiListItemIcon-root": {
                    minWidth: "40px"
                  },
                  ":hover": {
                    borderRadius: "0.75rem",
                    backgroundColor: "#F3F5F7 !important",
                  },
                  "& .active": {
                    background: "#000",
                    color: "#FFF !important",
                    fill: "#FFF !important",
                  },
                  "& .active svg": {
                    borderRadius: "0 !important",
                    fill: "#FFF !important",
                  },
                  "& .hover .MuiListItem-root": {
                    borderRadius: "0 !important",
                  },
                }}
              >
                <NavLink
                  to={data.url}
                  className={({ isActive }) =>
                    isActive ? "active" : "item-link"
                  }
                  style={{
                    textDecoration: "none",
                    width: "100%",
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon
                      sx={{
                        width: "21px",
                        height: "21px",
                      }}
                    >
                      {data.icon}
                    </ListItemIcon>

                    <ListItemText
                      primary={data.title}
                      primaryTypographyProps={{
                        fontSize: "15px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        display: "inline-block",
                      }}
                    />
                  </ListItemButton>
                </NavLink>
              </ListItem>
            )
          );
        })}
      </List>
      <Box sx={{padding: "2.5rem 1.2rem", fontSize: ".85rem", color: "#718096"}}>&#169;​ 2025 Verify v {process.env.REACT_APP_VERSION}. </Box>
    </Box>
  );
};

export default Sidebar;
